import React, { useEffect, useState, useCallback } from 'react'
import ConfiguracionLogic from '../../functions/logic/Configuracion'
import Select from 'react-select'

export default function Tableros(props) {
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [url, setUrl] = useState('')
    const [idReporte, setIdReporte] = useState('')
    const [idDataset, setIdDataset] = useState('')
    const [area, setArea] = useState('')
    const [areaOptions, setAreaOptions] = useState([])

    const getArea = useCallback(async (idArea, page, perPage) => {
        const resp = await ConfiguracionLogic.areasLogic(idArea, page, perPage, '')
        if (resp.success) {
            const areas = resp.data
                .filter(area => area.Nombre && area.Nombre.trim() !== '')
                .map(area => ({
                    value: area.id,
                    label: area.Nombre
                }))
            setAreaOptions(areas)
        }
    }, [])

    useEffect(() => {
        getArea(0, 1, 100);

        const storedName = localStorage.getItem("name");
        const storedDescription = localStorage.getItem("description");
        const storedUrl = localStorage.getItem("url");
        const storedArea = localStorage.getItem("area");
        const storedIdReporte = localStorage.getItem("idReporte");
        const storedIdDataset = localStorage.getItem("idDataset");

        if (storedName && storedDescription && storedUrl && storedArea) {
            setName(storedName);
            setDescription(storedDescription);
            setUrl(storedUrl);
            setArea(storedArea);
            setIdReporte(storedIdReporte);
            setIdDataset(storedIdDataset);
        } else if (props.formData.data) {
            console.log(props.formData)
            const datForm = props.formData.data;

            setName(datForm["nombreTablero"]);
            setDescription(datForm["descripcion"]);
            setUrl(datForm["urlReporte"]);
            setIdReporte(datForm["idReporte"]);
            setIdDataset(datForm["idDataset"]);

            if (datForm["listTablero"] && datForm["listTablero"].length > 0) {
                setArea(datForm["listTablero"][0]['idArea']);
                localStorage.setItem("area", datForm["listTablero"][0]['idArea']);
            }

            localStorage.setItem("name", datForm["nombreTablero"]);
            localStorage.setItem("description", datForm["descripcion"]);
            localStorage.setItem("url", datForm["urlReporte"]);
            localStorage.setItem("idReporte", datForm["idReporte"]);
            localStorage.setItem("idDataset", datForm["idDataset"]);
        }
    }, [props, getArea]);


    return (
        <div className="row justify-content-center">
            <div className="card-body">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label>Nombres</label>
                            <input
                                id="name"
                                name="name"
                                type="text"
                                maxLength={500}
                                value={name}
                                onChange={e => {
                                    setName(e.target.value)
                                    localStorage.setItem('name', e.target.value)
                                }}
                                className="form-control"
                                placeholder="Ingresar nombre"
                            />
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label>Descripción</label>
                            <textarea
                                id="description"
                                name="description"
                                type="text"
                                maxLength={500}
                                value={description}
                                onChange={e => {
                                    setDescription(e.target.value)
                                    localStorage.setItem('description', e.target.value)
                                }}
                                className="form-control"
                                placeholder="Ingresar descripción"
                            />
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label>Url</label>
                            <input
                                id="url"
                                name="url"
                                maxLength={500}
                                type="text"
                                value={url}
                                onChange={e => {
                                    setUrl(e.target.value)
                                    localStorage.setItem('url', e.target.value)
                                }}
                                className="form-control"
                                placeholder="Ingresar Url"
                            />
                        </div>
                    </div>
                    {/* <div className="col-sm-12">
                        <div className="form-group">
                            <label>Id Reporte</label>
                            <input
                                id="idReporte"
                                name="idReporte"
                                maxLength={500}
                                type="text"
                                value={idReporte}
                                onChange={e => {
                                    setIdReporte(e.target.value)
                                    localStorage.setItem('idReporte', e.target.value)
                                }}
                                className="form-control"
                                placeholder="Ingresar id Reporte"
                            />
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label>Id Dataset</label>
                            <input
                                id="idDataset"
                                name="idDataset"
                                maxLength={500}
                                type="text"
                                value={idDataset}
                                onChange={e => {
                                    setIdDataset(e.target.value)
                                    localStorage.setItem('idDataset', e.target.value)
                                }}
                                className="form-control"
                                placeholder="Ingresar id Dataset"
                            />
                        </div>
                    </div>*/}
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label>Área</label>
                            <Select
                                name="area"
                                id="area"
                                value={areaOptions.find(option => option.value === area)} // Mostrar el área seleccionada
                                onChange={selectedOption => {
                                    setArea(selectedOption.value)
                                    localStorage.setItem('area', selectedOption.label)
                                }}
                                options={areaOptions}
                                placeholder="Seleccione una área"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999
                                    })
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
